// project imports
import config from "../config";
import example from "../json/gatherfactsandstatistics";
// action - state management
import * as actionTypes from "./actions";

export const initialState = {
  isOpen: [], // for active default menu
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  opened: false,
  token: "",
  ediitorTitle: "",
  downloadTitle:"",
  snackbarStatus: {},
  jsonobject: {},
  endPoint: 'ai/metaDescription',
  profile:{},
  isLogging:false,
  reset:false,
  tokenExpire:"",
  seoData:{},
  seoSearch:"",
  seoSearchEmail:"",

};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const aiwritemateReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id],
      };
    case actionTypes.JSON_OBJECT:
      return {
        ...state,
        jsonobject: action.jsonobject,
      };
      case actionTypes.IS_LOGGIN:
        return {
          ...state,
          isLogging: action.isLogging,
        };
      case actionTypes.PROFILE:
        return {
          ...state,
          profile: action.profile,
        };  
        case actionTypes.SEO_DATA:
          return {
            ...state,
            seoData: action.seoData,
          };  case actionTypes.SEO_DATA:
          return {
            ...state,
            seoData: action.seoData,
          }; 
      
          case actionTypes.SEO_SEARCH:
            return {
              ...state,
              seoSearch: action.seoSearch,
            }; 
            case actionTypes.SEO_SEARCH_EMAIL:
              return {
                ...state,
                seoSearchEmail: action.seoSearchEmail,
              }; 
            
        case actionTypes.RESET:
          return {
            ...state,
            reset: action.reset,
          };     
    case actionTypes.END_POINT:
      return {
        ...state,
        endPoint: action.endPoint,
      };
      
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened,
      };
    case actionTypes.EDITOR_TITLE:
      return {
        ...state,
        ediitorTitle: action.ediitorTitle,
      };
      case actionTypes.DOWNLOAD_TITLE:
        return {
          ...state,
          downloadTitle: action.downloadTitle,
        };      
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily,
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius,
      };
    case actionTypes.SNACKBAR_STATUS:
      return {
        ...state,
        snackbarStatus: action.snackbarStatus,
      };
    case actionTypes.TOKEN:
      return {
        ...state,
        token: action.token,
      };
      case actionTypes.TOKEN_EXPIRE:
        return {
          ...state,
          tokenExpire: action.tokenExpire,
        };
    case actionTypes.LOGOUT:
      return {
        ...initialState,       
   
      };
    default:
      return state;
  }
};

export default aiwritemateReducer;
